import React from 'react';

import CountryAssistanceSeekingPOASection from './CountryAssistanceSeekingPOASection';

const textByType = {
  Request: 'needs of',
  Provided: 'provided by',
  Received: 'received by'
};

class CountryAssistanceSeekingPOAPanel extends React.Component {
  renderSections() {
    return this.props.data.map((data, index) => {
      return (
        <CountryAssistanceSeekingPOASection
          data={ data }
          key={ index }
          thematicDict={ this.props.thematicDict }
          defaultColor={ this.props.defaultColor }
        />
      )
    });
  }

  render() {
    const {
      data, countryName,
      reportSourceYear, type
    } = this.props;

    if (data.length > 0) {
      return (
        <div className="panel panel-default assistance-page-panel">
          <div className="panel-heading">
            <h3 style={{ display: 'inline' }}>
              Assistance { textByType[type] } { countryName }
            </h3>
            <span className="pull-right">Data source: POA reporting</span>
          </div>
          <div className="panel-body">
            <div className="assistance-seeking-country-record container-fluid">
              <p className="pull-right">
                <strong>Recency of information: </strong>
                National Report { reportSourceYear }
              </p>
              <div>{ this.renderSections() }</div>
            </div>
          </div>
        </div>
      )
    } else {
      return null;
    }
  }
}

export default CountryAssistanceSeekingPOAPanel;



// WEBPACK FOOTER //
// ./src/components/CountryAssistance/CountryAssistanceSeekingPOAPanel.js